/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
    },
    content: {
        flexGrow: 1,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        ...theme.custom.homePage.styles
    },
    appBarSpacer: {
        minHeight: theme.spacing(28.5)
    },
    homeTitle: {
        ...theme.custom.homePage.title.styles,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    homeSubTitle: {
        ...theme.custom.homePage.subTitle.styles,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    homeTitleBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    homeTitleButtons: {
        width: '470px',
        textAlign: 'left',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            marginBottom: theme.spacing(12)
        }
    },
    homeBanner: {
        ...theme.custom.homePage.banner.styles,
        maxWidth: '700px',
    },
    signUpButton: {
        fontSize: '13px',
        lineHeight: '16px',
        textTransform: 'capitalize',
        width: '179px',
        height: '48px',
        borderRadius: '25px',
        marginRight: '16px'
    },
    browseButton: {
        ...theme.custom.homePage.browseButton.styles
    },
    browseButtonFeatured: {
        ...theme.custom.homePage.sections.featuredApis.browseButton.styles
    },
    introVideoTitle: {
        ...theme.custom.homePage.sections.introVideo.title.styles,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    introVideoSubTitle: {
        ...theme.custom.homePage.sections.introVideo.subTitle.styles,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    featuredTitle: {
        ...theme.custom.homePage.sections.featuredApis.title.styles,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    featuredSubTitle: {
        ...theme.custom.homePage.sections.featuredApis.subTitle.styles,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    organization: {
        ...theme.custom.homePage.sections.organization.styles
    },
    organizationTitle: {
        ...theme.custom.homePage.sections.organization.title.styles,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    organizationSubTitle: {
        ...theme.custom.homePage.sections.organization.subTitle.styles,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    organizationCardTitle: {
        ...theme.custom.homePage.sections.organization.cardStyles.title
    },
    organizationCardContent: {
        ...theme.custom.homePage.sections.organization.cardStyles.content
    },
    organizationCardIcon: {
        ...theme.custom.homePage.sections.organization.cardStyles.icon
    },
    useCases: {
        ...theme.custom.homePage.sections.useCases.styles
    },
    useCasesTitle: {
        ...theme.custom.homePage.sections.useCases.title.styles,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    useCasesSubTitle: {
        ...theme.custom.homePage.sections.useCases.subTitle.styles,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    useCasesCardTitle: {
        ...theme.custom.homePage.sections.useCases.cardStyles.title
    },
    useCasesCardContent: {
        ...theme.custom.homePage.sections.useCases.cardStyles.content
    },
    useCasesCardIcon: {
        ...theme.custom.homePage.sections.useCases.cardStyles.icon
    },
    devBlogs: {
        ...theme.custom.homePage.sections.developerBlog.styles
    },
    blogTitle: {
        ...theme.custom.homePage.sections.developerBlog.title.styles,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    blogSubTitle: {
        ...theme.custom.homePage.sections.developerBlog.subTitle.styles,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    blogCardTitle: {
        ...theme.custom.homePage.sections.developerBlog.cardStyles.title
    },
    blogCardAuthor: {
        ...theme.custom.homePage.sections.developerBlog.cardStyles.author
    },
    blogCardContent: {
        ...theme.custom.homePage.sections.developerBlog.cardStyles.content
    },
    blogReadMoreBtn: {
        ...theme.custom.homePage.sections.developerBlog.cardStyles.readMoreButton
    },
    iframe: {
        ...theme.custom.homePage.sections.introVideo.videoIFrame,
        [theme.breakpoints.down('sm')]: {
            height: '100%',
            width: '100%'
        }
    },
}));
